import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function CtaSection() {
  const { t, path } = useI18n();

  return (
    <section className="py-16 lg:py-20 border-t border-border">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center reveal">
          <h2 className="font-serif text-[40px] lg:text-[56px] leading-[1.05] tracking-tight">
            {t.home.ctaTitleA} <br className="hidden sm:block" />
            <span className="italic">{t.home.ctaTitleB}</span>
          </h2>
          <p className="mt-5 text-lg text-muted-foreground leading-relaxed">
            {t.home.ctaBody}
          </p>
          <div className="mt-7 flex justify-center">
            <Link
              to={path("contact")}
              className="inline-flex items-center rounded-md bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              {t.nav.demo}
            </Link>
          </div>
          <p className="mt-4 text-sm text-muted-foreground">
            {t.home.ctaEmailPrefix}{" "}
            <a href="mailto:kontakt@medessa.pl" className="text-foreground underline underline-offset-4 decoration-border hover:decoration-foreground">
              kontakt@medessa.pl
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
